const prefix = 'SHORTLINK';

export const GET_SHORTLINK_PAGE_START = `${prefix}/GET_PAGE_START`;
export const GET_SHORTLINK_PAGE_SUCCESS = `${prefix}/GET_PAGE_SUCCESS`;
export const GET_SHORTLINK_PAGE_FAIL = `${prefix}/GET_PAGE_FAIL`;
